import { biometryApi } from '~/app/modules/biometry/utils/api.const';

import { TYPE_PHOTO_ID } from '~/app/modules/biometry/utils/upload.const';

export class UploadPhotoService {
  ctx;

  constructor(ctx) {
    this.ctx = ctx;
  }

  createFormData = snapshots => {
    const { front, back, selfie } = snapshots;

    const formData = new FormData();

    if (front) {
      formData.append(TYPE_PHOTO_ID.FRONT.toString(), front);
    }

    if (back) {
      formData.append(TYPE_PHOTO_ID.BACK.toString(), back);
    }

    if (selfie) {
      formData.append(TYPE_PHOTO_ID.SELFIE.toString(), selfie);
    }

    return formData;
  };

  upload = async snapshots => {
    const payload = this.createFormData(snapshots);

    const { success } = await this.ctx.$api.dispatch(biometryApi.uploadPhotos, payload);

    if (success) {
      await this.ctx.$auth.fetchUser();
    }

    return success;
  };
}
